import moment from "moment";

import { SuplementsOptions } from "./supplement.types";
import { getPolicyData } from "../../services/utils";
import { getPolicyEndDate } from "../forms/supplements/utils";
import { stringDateFormat } from "../../utils/time";
import { getText } from "../../utils/literales";
import { ILiteral } from "../../services/LiteralesServices.dto";
import { Supplement } from "../../services/SupplementsServices.dto";

export const getTitles = () => {
    return  {
        newIncorporation: 'Incorporación nuevo asegurado',
        basicData: 'Cambio de datos básicos',
    }   
}

export const generateArray = (data: Supplement[]): void => {
    let newArray: SuplementsOptions[] = [];

    for (let i = 0; i < data.length; i++) {
        let newObj: SuplementsOptions = { title: '', child: [] };

        const titleMap: { [key: string]: string } = {
            'Cambio de datos básicos': 'CAMBIO DATOS BASICOS',
            'Suplementos económicos': 'SUPLEMENTOS ECONOMICOS',
            'Suplementos administrativos': 'SUPLEMENTOS ADMINISTRATIVOS'
          };
          
        newObj.title = data[i].title in titleMap ? titleMap[data[i].title] : data[i].title;

        let childTitles: string[] = [];

        for (let j = 0; j < data[i].child.length; j++) {
            childTitles.push(data[i].child[j].title);
        }

        newObj.child = childTitles;

        newArray.push(newObj);
    } 
}

export const getMediatorCompleteName = (): string => {
    const loggedMediatorString = localStorage.getItem("loggedMediator");
    const loggedMediator = loggedMediatorString
      ? JSON.parse(loggedMediatorString)
      : { mediatorCode: "" };
    let selectedMediator = loggedMediator.relatedMediators.find((med: {mediatorCode: string}) => med.mediatorCode === getPolicyData().mediator);
    if (!selectedMediator) selectedMediator = loggedMediator;
    return `${selectedMediator.mediatorCode} - ${selectedMediator.mediatorName} - ${selectedMediator.orderNif}`
}

export function getRemaindingDays(date: string, endDate: string): number {
    const inputDate = moment(date, "DD/MM/YYYY");
    const firstDayOfMonth = moment(endDate, "DD/MM/YYYY").startOf('month');
    const remaindingDays = firstDayOfMonth.diff(inputDate, 'days');
    return remaindingDays;
}

export function getRemaindingDaysValidation(value: string, literales: ILiteral[] = []): {
    remaindingDays: number;
    modalMainText: string;
    warning: boolean;
} {
    const endDate = getPolicyEndDate();
    const endDateFormated = stringDateFormat(endDate);
    const remaindingDays = getRemaindingDays(value, endDateFormated);
    if (remaindingDays <= 25) {
        return {
            remaindingDays,
            warning: true,
            modalMainText: getText(
                literales,
                "supplements-date-error-new-supplement",
                "La fecha de renovación esta cercana y no se permite hacer suplementos",
            ),
        };
    }
    if (remaindingDays <= 60) {
        return {
            remaindingDays,
            warning: true,
            modalMainText: getText(
                literales,
                "supplements-date-warning",
                "La fecha de renovación esta cercana téngalo en cuenta a la hora de solicitar el suplemento",
            ),
        };
    }
    return { remaindingDays, warning: false, modalMainText: "" };
}

export function getOnClickSupplementValidation({
    fechaEfectoSuplemento,
    subramo,
    remaindingDays,
    id,
    literales = [],
}: {
    fechaEfectoSuplemento: string;
    subramo: string;
    remaindingDays: number;
    id: string;
    literales: ILiteral[];
}): {
    modalMainText: string;
    warning: boolean;
} {
    if (!fechaEfectoSuplemento || fechaEfectoSuplemento === "Invalid date") {
        return {
            warning: true,
            modalMainText: getText(
                literales,
                "supplements-date-input-warning",
                "Por favor, añada una fecha válida para el campo FECHA DE EFECTO DE SUPLEMENTO",
            ),
        };
    }

    if (subramo.toLocaleUpperCase().includes("SALUD") || subramo.toUpperCase().includes("DENTAL")) {
        if (remaindingDays <= 45 && id === "/alta-asegurado") {
            return {
                warning: true,
                modalMainText: getText(
                    literales,
                    "supplements-date-error-new-insured",
                    "No está permitido realizar un suplemento de incorporación de asegurado 45 días antes de la renovación de la póliza",
                ),
            };
        }
        if (remaindingDays <= 25) {
            return {
                warning: true,
                modalMainText: getText(
                    literales,
                    "supplements-date-error-new-supplement",
                    "La fecha de renovación esta cercana y no se permite hacer suplementos",
                ),
            };
        }
    }

    return { warning: false, modalMainText: "" };
}
